var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-user-add-to-homescreen"},[_c('IconThirdSlide1'),_c('p',{staticClass:"description",style:({ lineHeight: '2' })},[_c('br'),_vm._v(" Poshspaceのご利用は、"),_c('br'),_vm._v(" スマートフォンのホーム画面への"),_c('br'),_vm._v(" 登録が便利です。 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }